import { RESOURCE_NAME } from '@esentai/core/features/parkingLevelThreeWhitelist/consts';
import { canCreate, canRead, canUpdate } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

export const canReadLevelThreeWhitelist = authorizeIf(canRead(RESOURCE_NAME));
export const canCreateParkingLevelThreeWhitelist = authorizeIf(
  canCreate(RESOURCE_NAME),
);
export const canUpdateParkingLevelThreeWhitelist = authorizeIf(
  canUpdate(RESOURCE_NAME),
);
